import type { CeoPaymentApprovalRow } from '@shared/api';
import { ApprovalRow } from './ApprovalRow';
import {
  RightAlignTh,
  Section,
  StickyRecipientTh,
  StickyTh,
  Table,
  TableWrap,
  Title,
} from './styles';
import type { DecideApprovalFn, InlineAmountsMap } from './types';

interface ApprovalsTableProps {
  items: CeoPaymentApprovalRow[];
  inlineAmounts: InlineAmountsMap;
  onInlineAmountChange: (id: string, amount: number) => void;
  can_write: boolean;
  isDeciding: boolean;
  onDecide: DecideApprovalFn;
}

export function ApprovalsTable({
  items,
  inlineAmounts,
  onInlineAmountChange,
  can_write,
  isDeciding,
  onDecide,
}: ApprovalsTableProps) {
  return (
    <Section>
      <Title>Очередь заявок на оплату ({items.length})</Title>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>№ заявки / Дата</th>
              <th>Приоритет</th>
              <StickyRecipientTh>Контрагент / Счёт списания</StickyRecipientTh>
              <th>Назначение и инициатор</th>
              <th>Контроль БДДС</th>
              <RightAlignTh $minWidth={200}>Запрошено / К акцепту</RightAlignTh>
              <RightAlignTh>Факт по выписке</RightAlignTh>
              <th>Статус</th>
              {can_write && <StickyTh>Решение Гендиректора</StickyTh>}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <ApprovalRow
                key={item.id}
                item={item}
                inlineAmount={inlineAmounts[item.id]}
                onInlineAmountChange={onInlineAmountChange}
                can_write={can_write}
                isDeciding={isDeciding}
                onDecide={onDecide}
              />
            ))}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
